import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import LoginPage from './LoginPage';
import MenuPage from './MenuPage';
import TutorCrud from './TutorCrud';
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import { useNavigate } from 'react-router-dom';

const App = () => {

    const navigate = useNavigate();
    const usuario = localStorage.getItem("nomeUsuario");
    const sair = async (e) => {
            e.preventDefault();
            try {
               
                localStorage.removeItem('token');
                localStorage.removeItem('idUsuario');
                localStorage.removeItem('nomeUsuario');
               
                navigate('/');
            } catch (error) {
                alert('Falha no efetuar Logout.');
            }
        };
    

    return (
       <div className='container-fluid'>
         <nav className="navbar navbar-expand-lg navbar-light bg-light mb-4">

    <Link className="navbar-brand" to="/menu">Menu</Link>

    <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
    >
        <span className="navbar-toggler-icon"></span>
    </button>

    <div className="collapse navbar-collapse" id="navbarSupportedContent">

        {/* Menu esquerdo */}
        <ul className="navbar-nav me-auto mb-2 mb-lg-0">

            <li className="nav-item">
                <Link className="nav-link" to="/tutor">Tutores</Link>
            </li>

            <li className="nav-item">
                <Link className="nav-link" to="/paciente">Paciente</Link>
            </li>

            <li className="nav-item">
                  
                <Link className="nav-link" to="/exame">Exame</Link>
            </li>
            <li className="nav-item">
                  
                <Link className="nav-link" to="/consutarexames">Consultar Exames</Link>
            </li>

        </ul>

        {/* Menu direito: nome + dropdown */}
        <ul className="navbar-nav ms-auto">

            <li className="nav-item dropdown">

                <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    id="usuarioMenu"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                >
                    {usuario} {/* ← Nome do usuário */}
                </a>

                <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="usuarioMenu">
                    <li><button className="dropdown-item" onClick={sair}>Sair</button></li>
                </ul>

            </li>

        </ul>

    </div>
</nav>

</div>
       
    );
};

export default App;
